import React from 'react';
import T from 'prop-types';
import cx from 'classnames';

import Container from '../../../../components/Container';
import Tooltip from '../../../../components/Tooltip';

const DashboardTabsBar = ({ sections, active, onScrollToSection }) => (
  <nav className="dashboard-tabs-bar">
    <Container maxWidth={1128}>
      <div className="dashboard-tabs-bar__list">
        {sections.map((section) => (
          <Tooltip
            key={section.id}
            content={section.tooltip}
            placement="bottomLeft"
            colorVariant="light"
          >
            <span
              className={cx('dashboard-tabs-bar__tab', { active: active?.id === section.id })}
              onClick={() => onScrollToSection(section.id)}
            >
              {section.label}
            </span>
          </Tooltip>
        ))}
      </div>
    </Container>
  </nav>
);

DashboardTabsBar.propTypes = {
  sections: T.arrayOf(
    T.shape({
      id: T.string.isRequired,
      label: T.string.isRequired,
      tooltip: T.string,
    })
  ).isRequired,
  active: T.shape({ id: T.string.isRequired }),
  onScrollToSection: T.func.isRequired,
};

export default DashboardTabsBar;
